import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core'
import MapOutlinedIcon from '@material-ui/icons/MapOutlined'

import { useProject } from '@/pages/projects-form/contexts/project-context'

import { Regions } from './regions'
import { useStyles } from './styles'

export function Menu() {
  const classes = useStyles()

  const {
    context: {
      activeStep,
      goToFirstStep,
      goToSecondStep,
      isSuccessMutation,
      isLoadingMutation,
      isEditProjectPage,
    },
  } = useProject()

  const title = isEditProjectPage ? 'Editar Projeto' : 'Adicionar Projeto'

  return (
    <aside className={classes.aside}>
      <Typography variant='h1'>Projetos</Typography>

      <List className={classes.list}>
        <ListItem
          button
          selected={activeStep === 1}
          disabled={isSuccessMutation || isLoadingMutation}
          onClick={goToFirstStep}
        >
          <ListItemIcon>
            <MapOutlinedIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText
            primary={title}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem
          button
          selected={activeStep === 2}
          disabled={isSuccessMutation || isLoadingMutation}
          onClick={goToSecondStep}
        >
          <ListItemIcon>
            <span className='material-symbols-outlined'>upload_file</span>
          </ListItemIcon>
          <ListItemText
            primary='Selecionar Polígonos'
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
      </List>

      <Regions />
    </aside>
  )
}
